import { Focus } from '@tiptap/extensions'

export type { FocusOptions } from '@tiptap/extensions'
export { Focus } from '@tiptap/extensions'

export default Focus
